import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import ContractorsCatalogDisable from "./contractors-catalog-disable.view";
import ContractorsCatalogAddiotionalData from "./contractors-catalog-data.view";
import ContractorsCatalogSort from "./contractors-catalog-sort.view";
import ContractorsCatalogEditView from "./contractors-catalog-detail.view";
import ContractorsCatalogAddContractor from "./contractors-catalog-add.view";
import ContractorsCatalogViewDocuments from "./contractors-catalog-documents.view";

const ContractorsCatalogConfigurationView = (props) => {

    let {
      token,
      nameComponentUser,
      setStateNameComponentUser,
      stateNameComponentUser,
      hideShowDetails,
      setHeaderTitleinDetail,
    } = props

    const { t } = useTranslation();

    const [showDetailComponent, setShowComponentDetail] = useState(false);
    const [showCompletedRequest, setShowCompletedRequest] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameComponentUser]);

    useEffect(() => {
        renderComponentContractorsCatalog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateNameComponentUser]);

    const renderComponentContractorsCatalog = useCallback(() => {
        switch (stateNameComponentUser) {
          case t("contractorsCatalogView-btn-add-provider"):
            return (
              <ContractorsCatalogAddContractor
                {...props}
              />
            );
            case t("contractorsCatalogView-btn-disable"):
            return (
              <ContractorsCatalogDisable 
                {...props}
              />
            );
            case t("contractorsCatalogView-btn-additional-data"):
            return (
              <ContractorsCatalogAddiotionalData 
                {...props}
              />
            );
            case t("contractorsCatalogView-btn-sort"):
              return (
                <ContractorsCatalogSort 
                  {...props}
                />
              );
            case t("contractorsCatalogView-btn-details"):
              return (
                <ContractorsCatalogEditView 
                  {...props}
                />
              );
            case t("contractorsCatalogView.watch.document"):
              return (
                <ContractorsCatalogViewDocuments 
                  {...props}
                />
              );
          default:
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [
        stateNameComponentUser,
        hideShowDetails,
        setHeaderTitleinDetail,
        token,
        showDetailComponent,
        showCompletedRequest,
      ]);
    
      return <>{renderComponentContractorsCatalog()}</>;
    };
    
export default ContractorsCatalogConfigurationView;